"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var api_client_1 = require("./api_client");
var auth_1 = require("./auth/auth");
var constants_1 = require("./constants");
var jwt_storage_1 = require("./jwt_storage");
var settings_1 = require("./settings");
var search_1 = require("./search");
var Guestia = /** @class */ (function () {
    function Guestia(params) {
        var _this = this;
        this.JWT = new jwt_storage_1["default"]();
        this.doJWTRequest = true;
        this.handleUnauthorizedResponse = function () {
            _this.JWT.remove();
        };
        this.params = Guestia.buildParams(params);
        this.apiClient = new api_client_1["default"]({
            JWTStorage: this.JWT,
            host: this.params.host,
            prefix: "/api/v" + this.params.apiVersion,
            onUnauthorized: this.handleUnauthorizedResponse
        });
        this.oauth = new auth_1["default"](this.apiClient, this.JWT, {
            authHost: this.params.authHost,
            authVersion: this.params.apiVersion,
            uid: this.params.uid
        });
        this.settings = new settings_1["default"](this.apiClient, this.JWT, {
            storage: this.params.storageProvider,
            schema: this.params.schema
        });
    }
    Guestia.buildParams = function (params) {
        return __assign({}, constants_1.DEFAULT_PARAMS, params);
    };
    // NOTE: fetch user jwt and set it to jwt storage
    Guestia.prototype.authorize = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.oauth.init().then(function (res) {
                if (res.jwt) {
                    _this.settings.loadState();
                    _this.JWT.set(res.jwt);
                }
                else {
                    _this.JWT.remove();
                }
                resolve({ jwt: res.jwt });
            });
        });
    };
    Guestia.prototype.getUserInfo = function () {
        return this.oauth.getUserInfo();
    };
    Guestia.prototype.userInfo = function () {
        // TOOD: rm
        return this.oauth.getUserInfo();
    };
    Guestia.prototype.getUserId = function () {
        return this.oauth.getUserId();
    };
    Guestia.prototype.getJWT = function () {
        return this.JWT.get();
    };
    Guestia.prototype.logout = function () {
        return this.oauth.logout();
    };
    Guestia.prototype.syncSettings = function () {
        return this.settings.sync();
    };
    Guestia.prototype.getSettings = function (key) {
        return this.settings.get(key);
    };
    Guestia.prototype.getAllSettings = function () {
        return this.settings.getAll();
    };
    Guestia.prototype.setSettings = function (key, value) {
        this.settings.set(key, value);
        return this.syncSettings();
    };
    Guestia.prototype.login = function (method) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.oauth
                .login(method)
                .then(function (_a) {
                var jwt = _a.jwt, userInfo = _a.userInfo;
                _this.afterLogin(jwt, userInfo).then(function () { return resolve({ jwt: jwt, userInfo: userInfo }); });
            })["catch"](reject);
        });
    };
    Guestia.prototype.jwtAuth = function (provider, idToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.oauth
                .jwtAuth(provider, idToken)
                .then(function (_a) {
                var jwt = _a.jwt, userInfo = _a.userInfo;
                _this.afterLogin(jwt, userInfo).then(function () { return resolve({ jwt: jwt, userInfo: userInfo }); });
            })["catch"](reject);
        });
    };
    Guestia.prototype.saveSearch = function (searchId, searchParams, cheapestTicket) {
        return search_1["default"].save(this.apiClient, searchId, searchParams, cheapestTicket);
    };
    Guestia.prototype.fetchSearches = function () {
        return search_1["default"].fetchSearches(this.apiClient);
    };
    Guestia.prototype.savePreviousSearches = function () {
        return search_1["default"].savePreviousSearches(this.apiClient);
    };
    Guestia.prototype.afterLogin = function (jwt, userInfo) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.JWT.set(jwt);
            _this.settings.loadState().then(resolve);
            _this.savePreviousSearches();
        });
    };
    return Guestia;
}());
exports["default"] = Guestia;
